// extracted by mini-css-extract-plugin
export var md = "_1z-4";
export var semantic = "_1z-5";
export var sm = "_1z-3";
export var text = "_1z-6";
export var toggleInput = "_1z-0";
export var toggleSwitch = "_1z-1";
export var xs = "_1z-2";